const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  connectionId: "",
  name: "",
};

const EHRSlice = createSlice({
  name: "connectedEHR",
  initialState,
  reducers: {
    setEHRData: (state, action) => {
      const { connectionId = null, ehrName = null } = action.payload || {};
      state.connectionId = connectionId;
      state.name = ehrName;
    },
  },
});

export default EHRSlice.reducer;
export const { setEHRData } = EHRSlice.actions;
